
module.exports = {
	title: 'Filter menu',
	status: 'ready',
	context: {
		title: 'Så arbetar vi för en bra arbetsmiljö.',
		data: '56%',
		dataText: 'av cheferna är kvinnor på FMV.',
		content: ' Män och kvinnor ska ha likvärdiga möjligheter till yrkes- och kompetensutveckling, ipsum dolor sit amet. ',
		linkText: 'Mer om vårt jämnställdhetsarbete'
	}
};
